import React from 'react';

import { InfoTable } from '../business-services';

import styles from './FixService.module.scss';

const FixService = ({ data }) => {
  return (
    <div className={styles.tables}>
      {data && (
        <div className='wrapper small-margin'>
          <InfoTable data={data} dark className={styles.tables__item} />
        </div>
      )}
    </div>
  );
};

export default FixService;
